import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup, ValidatorFn } from '@angular/forms';

@Directive({
    selector: '[appMustBeGreaterThan]',
    providers: [{ provide: NG_VALIDATORS, useExisting: AppMustBeGreaterThanDirective, multi: true }]
})
export class AppMustBeGreaterThanDirective implements Validator {
    @Input('appMustBeGreaterThan')
    appMustBeGreaterThan: string[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        return MustBeGreaterThan(this.appMustBeGreaterThan[0], this.appMustBeGreaterThan[1])(formGroup);
    }
}

export function MustBeGreaterThan(controlName: string, matchingControlName: string): ValidatorFn {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        // return null if controls haven't initialised yet
        if (!control || !matchingControl || isNaN(control.value) || isNaN(matchingControl.value)) {
          return null;
        }

        // return null if another validator has already found an error on the matchingControl
        if (matchingControl.errors && !matchingControl.errors.mustBeGreaterThan) {
            return null;
        }

        // set error on matchingControl if validation fails
        if (Number(control.value) > Number(matchingControl.value)) {
            matchingControl.setErrors(null);
        } else {
            matchingControl.setErrors({ mustBeGreaterThan: true });
        }
    };
}
